import { Tournament } from 'Src/models/tournament';
import { KIND } from 'Src/consts/school';

export const hasUnionParticipant = (tournament: Tournament) =>
  (tournament.schools || []).some(school => school.kind === KIND.SCHOOL_UNION);
